import React, { useEffect, useState, useRef } from "react";

import "../../Tv/Iplbattle/iplbattle.css";

import useUserInfo from "../../../Hooks/useUserInfo";
import { logPageView } from "../../../components/analytics";
import Task from "../Task";
import { useAudio } from "../../../Providers/AudioProvider";
import { userGameRewards, getUserDetails1 } from "../../../apis/user";
import Swal from "sweetalert2";

const Flappy = () => {
  const { userDetails, watchScreen, updatewatchScreenInfo, updateUserInfo } =
    useUserInfo();
  const canvas = document.getElementById("currentScore");
  console.log(canvas, "canvas");
  const [isLoading, setIsLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [ballCount, setBallCount] = useState(0);
  const [displayScore, setDisplayScore] = useState(0);
  const [isGameActive, setIsGameActive] = useState(true); // Add game state
  const [highScore, setHighScore] = useState(() => {
    try {
      const stored = localStorage.getItem("flappyHighScore");
      return stored ? parseInt(stored) : 0;
    } catch (error) {
      console.error("Error loading high score from localStorage:", error);
      return 0;
    }
  });
  const [apiHighScore, setApiHighScore] = useState(0);

  // Debug logging for highscore values
  useEffect(() => {
    console.log("🏆 Flappy highscore state update:");
    console.log("🏆 highScore:", highScore);
    console.log("🏆 apiHighScore:", apiHighScore);
    console.log(
      "🏆 Math.max(highScore, apiHighScore):",
      Math.max(highScore, apiHighScore)
    );
  }, [highScore, apiHighScore]);
  // Ensure runs are always even
  const playClick = useAudio();
  useEffect(() => {
    logPageView("Flappy GAME PAGE", "Flappy GAME PAGE");
  }, []);

  // Fetch initial high score from API on component mount
  useEffect(() => {
    const fetchInitialHighScore = async () => {
      try {
        const res = await getUserDetails1();
        console.log("🏆 Flappy API response:", res);
        console.log("🏆 Flappy API response keys:", Object.keys(res || {}));
        console.log("🏆 Flappy gameRewards:", res?.gameRewards);
        console.log("🏆 Flappy games array:", res?.gameRewards?.games);

        if (res && res.gameRewards && res.gameRewards.games) {
          const flappyGame = res.gameRewards.games.find(
            (game) => game.gameType === "flappy"
          );
          console.log("🏆 Flappy game found:", flappyGame);
          console.log("🏆 Flappy highScore:", flappyGame?.highScore);

          if (flappyGame && flappyGame.highScore) {
            setApiHighScore(flappyGame.highScore);
            // Update local high score if API high score is higher
            if (flappyGame.highScore > highScore) {
              setHighScore(flappyGame.highScore);
              localStorage.setItem(
                "flappyHighScore",
                flappyGame.highScore.toString()
              );
            }
          } else {
            console.log("🏆 No flappy highscore found in API response");
          }
        } else {
          console.log("🏆 No gameRewards.games found in API response");
        }
      } catch (error) {
        console.error("Failed to fetch initial high score:", error);
      }
    };

    fetchInitialHighScore();
  }, []);

  //   useEffect(() => {
  //     const handleScoreUpdate = (e) => {
  //       setScore(e.detail);
  //     };

  //     window.addEventListener("scoreUpdate", handleScoreUpdate);
  //     return () => window.removeEventListener("scoreUpdate", handleScoreUpdate);
  //   }, []);
  const handleApiResponse = async (points) => {
    if (points <= 0) {
      return;
    }

    updateUserInfo((prev) => ({
      ...prev,
      isLoading: true,
    }));
    setIsLoading(true);
    try {
      const apiData = {
        gamePoints: points,
        gameType: "flappy",
      };
      const res = await userGameRewards(apiData);
      if (res) {
        console.log("🏆 Flappy handleApiResponse - API response:", res);
        console.log(
          "🏆 Flappy handleApiResponse - gameRewards:",
          res?.gameRewards
        );
        console.log(
          "🏆 Flappy handleApiResponse - games array:",
          res?.gameRewards?.games
        );

        // Extract highscore from API response
        if (res.gameRewards && res.gameRewards.games) {
          const flappyGame = res.gameRewards.games.find(
            (game) => game.gameType === "flappy"
          );
          console.log(
            "🏆 Flappy handleApiResponse - flappy game found:",
            flappyGame
          );
          console.log(
            "🏆 Flappy handleApiResponse - flappy highScore:",
            flappyGame?.highScore
          );

          if (flappyGame && flappyGame.highScore) {
            setApiHighScore(flappyGame.highScore);
            // Update local high score if API high score is higher
            if (flappyGame.highScore > highScore) {
              setHighScore(flappyGame.highScore);
              localStorage.setItem(
                "flappyHighScore",
                flappyGame.highScore.toString()
              );
            }
          } else {
            console.log(
              "🏆 Flappy handleApiResponse - No flappy highscore found"
            );
          }
        } else {
          console.log(
            "🏆 Flappy handleApiResponse - No gameRewards.games found"
          );
        }

        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));
        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
        setIsLoading(false);
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
      setIsLoading(false);
    }
  };

  const showGameOverPopup = (finalScore) => {
    const isPointsReached =
      watchScreen?.LoginMessage ===
      "You have already reached the maximum rewards limit";

    Swal.fire({
      html: `
        <div style="text-align: center; padding: 20px;">
          <div style="font-size: 24px; margin-bottom: 20px; color: #333;">
            ${finalScore > 0 ? "TOKENS EARNED" : "GAME OVER"}
          </div>
          <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 20px;">
            <img src="https://d1ccopf5cw1hft.cloudfront.net/s3data/coinlogo.png" alt="coin" style="width: 30px; height: 30px; margin-right: 10px;">
            <span style="font-size: 32px; font-weight: bold; color: #ff6b35;">${finalScore}</span>
          </div>
          <div style="font-size: 16px; color: #666; margin-bottom: 10px;">
            Best Score: ${Math.max(highScore, apiHighScore)}
          </div>
          <div style="font-size: 14px; color: #888;">
            ${
              finalScore > 0
                ? "Great job! 🎉 Keep playing to beat your high score!"
                : "Keep practicing! 🐦 Try to score higher next time!"
            }
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Play Again",
      cancelButtonText: "Exit",
      confirmButtonColor: "#ff6b35",
      cancelButtonColor: "#6c757d",
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        // Play again - restart the game
        const iframe = document.getElementById("flappy-iframe");
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ type: "RESTART_GAME" }, "*");
        }
        // Reset all game state
        setScore(0);
        setDisplayScore(0);
        setIsLoading(false);
      } else {
        // Exit game
        handleApiResponse(finalScore);
        toogleMenu(Task, "task");
      }
    });
  };
  useEffect(() => {
    // Listen for messages from the iframe
    const handleMessage = (event) => {
      // Verify the origin of the message for security
      if (event.origin !== window.location.origin) return;

      const { type, data } = event.data;

      switch (type) {
        case "FLAPPY_GAME_OVER":
          setScore(data.score);
          if (data.score > 0) {
            // Update local high score
            const currentHighScore = Math.max(highScore, apiHighScore);
            if (data.score > currentHighScore) {
              setHighScore(data.score);
              localStorage.setItem("flappyHighScore", data.score.toString());
            }
            // Show game over popup with score
            showGameOverPopup(data.score);
          } else {
            // Show game over popup even for 0 score
            showGameOverPopup(0);
          }
          setDisplayScore(0);
          break;
        case "FLAPPY_SCORE_UPDATE":
          setDisplayScore(data.score);
          break;
        case "FLAPPY_HIGHSCORE_UPDATE":
          // Update highscore from iframe
          if (data.highScore && data.highScore > highScore) {
            setHighScore(data.highScore);
            localStorage.setItem("flappyHighScore", data.highScore.toString());
          }
          break;
        default:
          console.log("Unknown message type:", type);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  console.log(score, "kashdksahd");

  const ExitGame = () => {
    if (displayScore > 0) {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to exit the game?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continue",
        cancelButtonText: "Exit",
        reverseButtons: true, // Puts "Exit" on the left and "Continue" on the right
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("User chose to continue");
          // Add logic for continuing the game
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          handleApiResponse(score); // Use updated score
          toogleMenu(Task, "task");

          // Add logic for exiting the game
        }
      });
    } else {
      toogleMenu(Task, "task");
    }
  };

  const toogleMenu = () => {
    playClick();
    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: Task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  const startFreshGame = () => {
    // Reset all game state for fresh start
    setScore(0);
    setDisplayScore(0);
    setIsLoading(false);

    // Send restart message to iframe
    const iframe = document.getElementById("flappy-iframe");
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: "RESTART_GAME" }, "*");
    }

    console.log("🎮 Starting fresh Flappy Bird game");
  };

  // Handle iframe load to ensure proper initialization
  const handleIframeLoad = () => {
    console.log("🎮 Flappy Bird iframe loaded");
    // Send initial setup message to iframe
    const iframe = document.getElementById("flappy-iframe");
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: "INIT_GAME" }, "*");
    }
  };

  return (
    <div
      className="menupointer"
      style={{
        height: "100%",
        width: "100%",
        pointerEvents: "fill",
        backgroundColor: "#000",
        zIndex: "2",
      }}
    >
      <div className="row">
        <div className="col-12">
          <header style={{ position: "absolute", width: "100%" }}>
            <div class="score-container1">
              <img
                onClick={() => {
                  ExitGame();
                }}
                src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
                className="cancel-imgflappy"
                style={{ cursor: "pointer", width: "25px" }}
              />
              <div id="currentScore">Score : {displayScore}</div>
              <div
                style={{ color: "white", fontSize: "14px", marginLeft: "10px" }}
              >
                Best : {Math.max(highScore, apiHighScore)}
              </div>
            </div>
          </header>

          <iframe
            id="flappy-iframe"
            src={"/flappy/index.html"}
            onLoad={handleIframeLoad}
            style={{
              // width: "100%",
              height: "100vh",
              border: "none",
              //   pointerEvents: "fill",
              width: "100vw",
              // position: "fixed",
              bottom: "0%",
              overflow: "hidden",
            }}
            title="Flappy Bird Game"
          />
        </div>
      </div>
    </div>
  );
};
export default Flappy;
